<template>
	<div class="page" v-if="page">
		<section class="section">
			<div class="container content is-fullhd">
				<div class="columns is-multiline">
					<div class="column is-one-third" v-for="data in page.rounds">
						<div class="box">
							<table class="table is-fullwidth">
								<thead>
									<tr>
										<th colspan="2">Round {{ data.round }}</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="item in data.picks">
										<td class="has-text-right">{{ item.pick }}.</td>
										<td>
											<small class="is-pulled-right"
												>({{ item.player.team_abbr }} - {{ item.player.display_position }})</small
											>
											{{ item.player.name_full }}<br />
											<TeamLink :teamKey="item.team.key" :teamName="item.team.name" />
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import TeamLink from "@/components/TeamLink"

export default {
	components: {
		TeamLink,
	},
	computed: {
		league() {
			return this.$store.getters.activeLeague
		},
		page() {
			return this.$store.getters.activePage
		},
	},
	mounted() {
		this.$store.dispatch("setActivePage", "draft_rounds")
	},
}
</script>
